import { render, staticRenderFns } from "./addCRMSupport.vue?vue&type=template&id=3cff01e5"
import script from "./addCRMSupport.vue?vue&type=script&lang=js"
export * from "./addCRMSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports